import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/css/icons.css';
import '../../assets/css/style.css'
import { SERVER_IP, PORT, ud, jwt, auth_response_flow } from '../../Server'
import swal from 'sweetalert';
import axios from 'axios';


class ListLocation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            List: [],
            message: "",

        }
    }

    componentDidMount() {
        this.getList()
    }
    getList = () => {
        var data = {}
        let _this = this;
        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        axios.post(`${SERVER_IP}/location/list`, data, { withCredentials: true, headers: headers })
            .then(function (response) {
                if (response.data.error === false) {
                    if (response.data.locationsList) {
                        _this.setState({
                            List: response.data.locationsList,
                            message: response.data.locationsList.length === 0 ? "No Record Found." : ""
                        });
                    }
                } else {
                    auth_response_flow(response.data, (return_response) => {
                        if (return_response.error === false && return_response.retry === true) {
                            _this.getList();
                        }
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }



    createSOP = () => {
        sessionStorage.setItem('location_info', JSON.stringify({ operation_type: "create" }))
        window.location.href = "/create/createlocation"

    }
    EditSOP = (list) => {
        sessionStorage.setItem('location_info', JSON.stringify(Object.assign(list, { operation_type: "edit" })))
        window.location.href = "/create/createlocation"
    }


    render() {
      
        const { errors } = this.state;
        return (
            <div>
                <div class="xp-breadcrumbbar">
                    <div className="row">
                        <div className="col-md-6">
                            <h4 class="xp-page-title">Dashboard</h4>
                        </div>
                        <div class="col-md-12">
                            <div class="xp-breadcrumb">
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item"><a onClick={() => window.location.href = "/dashboard"}><i class="icon-home"></i> </a></li>
                                    <li class="breadcrumb-item active">Locations</li>
                                </ol>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-6 mt-4">
                            <button className="btn btn-primary btn-lg" title="New Workflow" onClick={this.createSOP}><i className="mdi mdi-plus mr-2"></i>New Location</button>
                        </div>
                        {/* <div className="col-md-6 col-lg-6">
                            <div class="xp-breadcrumb">
                                <ol class="breadcrumb"><li class="breadcrumb-item"><a onClick={() => window.location.href = "/dashboard"}><i class="icon-home"></i></a></li></ol>

                            </div>
                        </div> */}
                    </div>
                </div>
                <div class="xp-contentbar p-30">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="card m-b-30">
                                <div class="card-header dv-center space-between">
                                    <h5 class="card-title text-black mb-0">Location List</h5>

                                </div>

                                <div class="card-body">
                                    <div class="table-responsive">
                                        {this.state.List.length === 0 ?
                                            this.state.message === "" ?

                                                // loader
                                                <div className="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                                                // loader-end
                                                :
                                                <div className="message-no-record"> {this.state.message} </div>

                                            : null}

                                        <table class="table table-striped table-bordered mcqlist-taable">
                                            <thead>
                                                <tr>
                                                    <th className="text-center">S.N.</th>
                                                    <th style={{ width: "80%" }}>Location Name</th>
                                                    <th className="text-center">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.List.map((list, index) =>
                                                    <tr>
                                                        <td className="text-center"><strong>{index + 1}.</strong></td>
                                                        <td>{list.location_name}</td>
                                                        <td className="text-center">
                                                            <div class="tabledit-toolbar btn-toolbar" style={{ display: "block", margin: "0 auto" }}>
                                                                <div class="btn-group btn-group-sm">
                                                                    <button type="button" title="Edit" onClick={() => this.EditSOP(list)} class=" btn  btn-info"><i className="mdi mdi-pencil"></i></button>
                                                                    {/* <button type="button" title="Delete" disabled onClick={() => this.DeleteSop(list)} class="btn btn-sm btn-primary"><i className="mdi mdi-trash-can-outline"></i></button> */}

                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )}

                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                            </div>
                        </div>


                    </div>


                </div>
            </div>
        )
    }
}
export default ListLocation

